import { createFileRoute, notFound } from "@tanstack/react-router";
import NotFound from "@/components/NotFound";
import { parseSeriesParam } from "@/lib/showSlug";
import { ActorPage } from "@/modules/ActorPage";

// `{slug}-{id}`, the show param's shape: a malformed one is a 404 before
// anything is queried, like the player's. `actors` is a static segment, so
// it can't be taken for a show param.
export const Route = createFileRoute("/_default/actors/$actor")({
  loader: ({ params }) => {
    const actorId = parseSeriesParam(params.actor);
    if (!actorId) throw notFound();
    return { actorId };
  },
  notFoundComponent: NotFound,
  component: ActorPage,
});
